







































































































































































import { Base } from '@/base';
import Component from "vue-class-component";
import {mapMutations } from 'vuex';
import { regular } from '@/constants/commonContent';
import * as Web3Utils from 'web3-utils';
import { validData } from '@/constants/sidebarData';

@Component({
  name: 'InputsComponent',
  methods: {
    ...mapMutations(['initializationPending'])
  }
})
export default class InputsComponent extends Base{
  validData = validData;
  newOwners: any[] = [];
  private infoText: string = '';
  // Computed
  get getCurrentOwners() {
    let rows: any[] = [];
    for (let variable in this.getOwners) {
      let row: any = {};
      let member = this.getMembers[variable];
      row.name = member ? member.name : '';
      row.address = variable;
      row.email = member ? member.email : '';
      rows.push(row);
    }
    return rows;
  }
  get isPending() {
    return this.getPendings.initialization.update
  }
  // Methods
  isAddress(addr) {
    if (addr && addr.slice(0, 2) !== '0x') {
      return false;
    }
    return !addr ? null : Web3Utils.isAddress(addr);
  }
  isEmail(email) {
    return !email ? null : regular.validate.email.test(email);
  }
  isValidName(name) {
    return !name
            ? null
            : name.length >= validData.member.name.min &&
            name.length <= validData.member.name.max;
  }
  isCorrectNewOwner() {
    let validate: any = this.newOwners.length;
    this.newOwners.forEach(item => {
      if (!this.isAddress(item.ownerAddress)) {
        validate = false;
      }
      if (!this.isEmail(item.ownerEmail)) {
        validate = false;
      }
      if (
              item.ownerName.length < validData.member.name.min ||
              item.ownerName.length >= validData.member.name.max
      ) {
        validate = false;
      }
    });
    return validate;
  }
  addRow() {
    this.newOwners.push({
      ownerName: '',
      ownerAddress: '',
      ownerEmail: ''
    });
  }
  endInitiate() {
    this.newOwners = [];
    this.infoText =
            "You've initiated the owner. Now please sign your request (send the transaction).";
    this.initializationPending(true);
    this.initiateOwnersDapp({}).then(err => {
      this.initializationPending(true);
      if (err) return;
      this.$router.push('/');
      window.location.reload();
    }).catch((err) => {
      console.log(err);
      this.initializationPending(true);
    });
  }
  submitNewOwners() {
    this.addOwnersDapp(this.newOwners);
    this.newOwners = [];
  }
};
